import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export type DetailListItemProps = {
  attributeName?: string;
};

export const DetailListItem: React.FC<DetailListItemProps> = ({ attributeName, children }) => {
  if (!attributeName) {
    return (
      <Grid container style={{ paddingBottom: '8px', paddingTop: '8px' }}>
        {children}
      </Grid>
    );
  }

  return (
    <Grid container style={{ paddingBottom: '8px', paddingTop: '8px' }}>
      <Grid item xs={5}>
        <Typography variant="body2" color="textSecondary">
          {attributeName}
        </Typography>
      </Grid>
      <Grid item xs={7}>
        {children}
      </Grid>
    </Grid>
  );
};
